<template>
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
    <el-form-item label="工具分类" prop="theme">
      <el-select style="width: 100%;" v-model="ruleForm.theme" filterable allow-create default-first-option placeholder="可以设定自定义分类或下拉选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="工具名称" prop="name">
      <el-input v-model.number="ruleForm.name"></el-input>
    </el-form-item>
    <el-form-item label="工具描述" prop="description">
      <el-input v-model.number="ruleForm.description"></el-input>
    </el-form-item>
    <el-form-item label="工具截图" prop="image">
      <el-upload :data="uploadImages" :on-success="onSuccess" :on-change="onImageChange" :show-file-list="false" :before-upload="imageBeforeUpload" :accept="'image/*'" class="upload-demo" action="/api/admin/material/upWebToolImage" :file-list="imageList" list-type="picture" :multiple="false">
        <div style="width: 154px;height: 86px;border: 1px dashed #d9d9d9;" class="flex-a-c">
          <img v-if="imageUrl" :src="imageUrl" style="width: 154px;height: 86px;">
          <i v-else class="el-icon-plus avatar-uploader-icon">添加截图</i>
        </div>
      </el-upload>
    </el-form-item>
    <el-form-item label="html文件" prop="file">
      <el-upload :data="uploadFile" :on-success="onSuccess" :on-change="onFileChange" :before-upload="beforePpload" :accept="'.html'" class="upload-demo" action="/api/admin/material/upWebTool" :on-preview="handlePreview" :file-list="fileList" :auto-upload="false" ref="uploadHtml" :multiple="false">
        <el-button size="small" type="primary">选取html文件</el-button>
        <span slot="tip" class="el-upload__tip">只能上传html文件,且不超过5M</span>
      </el-upload>
    </el-form-item>
    <el-form-item class="flex-b-c" label-width="0px">
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      <el-button @click="resetForm('ruleForm')">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";

export default {
  name: 'AddWebTool',
  props: {
    tools: {
      type: Object,
      default: () => ({ })
    }
  },
  data() {
    let fileIsNull = (_1, _2, callback) => {
      if (this.fileList.length === 0) {
        callback(new Error('文件不能为空'));
      } else {
        callback();
      }
    };
    let imageIsNull = (_1, _2, callback) => {
      if (this.imageList.length === 0) {
        callback(new Error('文件不能为空'));
      } else {
        callback();
      }
    };
    return {
      options: [],
      ruleForm: {
        name: '',
        description: '',
        theme: ''
      },
      rules: {
        name: [{ required: true, message: '请输入工具名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入工具描述', trigger: 'blur' }],
        theme: [{ required: true, message: '请选择或添加分类', trigger: 'change' }],
        file: [{ required: true, validator: fileIsNull, trigger: 'blur' }],
        image: [{ required: true, validator: imageIsNull, trigger: 'blur' }]
      },
      fileList: [],
      imageList: [],
      uploadFile: {},
      uploadImages: {},
      imageUrl: ''
    }
  },
  created() {
    this.options = Object.keys(this.tools).map(v => ({ value: v, label: v }));
  },
  methods: {
    closeDialog(confirm) {
      if (confirm) {
        console.log(confirm);
      }
      this.dialogVisible = false;
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.uploadHtml.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('closeAddTool', false);
    },
    onFileChange(_, fileList) {
      this.fileList = fileList;
    },
    onImageChange(_, imageList) {
      this.imageList = imageList;
    },
    imageBeforeUpload() {
      let data = handleDataAndSign("/admin/material/upWebToolImage", {});
      // 必须这样的格式设置 uploadFile 不然无法通过上传校验
      // this.uploadImages = { ...this.uploadImages, ...data };
      this.uploadImages.v = data.v;
      this.uploadImages.t = data.t;
      this.uploadImages.token = data.token;
      this.uploadImages.s = data.s;
    },
    beforePpload() {
      let formData = { ...this.ruleForm };
      formData.group_id = this.$cookies.get("group_id");
      formData.user_id = this.$cookies.get("user_id");
      formData.thumbPath = this.imageUrl;
      let data = handleDataAndSign("/admin/material/upWebTool", formData);
      // 必须这样的格式设置 uploadFile 不然无法通过上传校验
      this.uploadFile.name = data.name;
      this.uploadFile.description = data.description;
      this.uploadFile.theme = data.theme;
      this.uploadFile.group_id = data.group_id;
      this.uploadFile.user_id = data.user_id;
      this.uploadFile.thumbPath = data.thumbPath;

      this.uploadFile.v = data.v;
      this.uploadFile.t = data.t;
      this.uploadFile.token = data.token;
      this.uploadFile.s = data.s;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    onSuccess(ref) {
      // console.log(ref);
      const { status, data: { type, md5, msg, path } } = ref;
      if (type === 'html' && status === 1) {
        this.$msg({ message: "工具添加成功!", type: "success", showClose: true });
        this.$emit('closeAddTool', true);
      }
      console.log(md5, msg);
      type === 'image' && (this.imageUrl = path);
    }
  }
}
</script>

<style>
</style>